import { $http } from '@/utils/https'
import {
    SET_ADVANTAGE_LIST_LOADING,
    SET_ADVANTAGE_LIST,
    GET_MAIN_SLIDER_LOADING,
    SET_MAIN_SLIDER
} from '../mutation-types';

import {
    GET_ADVANTAGE_LIST,
    GET_MAIN_SLIDER
} from '../action-types';


const state = {
    advantageList: null,
    advantageListLoading: false,
    mainSlider: null,
    mainSliderLoading: null,
};

const getters = {
    advantageList: state => state.advantageList,
    advantageListLoading: state => state.advantageListLoading,
    mainSlider: state => state.mainSlider,
    mainSliderLoading: state => state.mainSliderLoading,
};

const actions = {
    [GET_ADVANTAGE_LIST]: async ({ commit }) => {
        commit(SET_ADVANTAGE_LIST_LOADING, true);
        try {
            const response = await $http.get('v1/pages/advantage');
            commit(SET_ADVANTAGE_LIST, response.data.data.settings);
        }catch (e) {
            throw e;
        }finally {
            commit(SET_ADVANTAGE_LIST_LOADING, false);
        }
    },
    [GET_MAIN_SLIDER]: async ({ commit }) => {
        commit(GET_MAIN_SLIDER_LOADING, true);
        try {
            const response = await $http.get('v1/slider/banner');
            commit(SET_MAIN_SLIDER, response.data.data.slides.data);
        }catch (e) {
            throw e;
        }finally {
            commit(GET_MAIN_SLIDER_LOADING, false);
        }
    },
};

const mutations = {
    [SET_ADVANTAGE_LIST](state, list) {
        //transform result
        const arr = [];
        const countElem = list.length / 2;
        list.forEach((e, index) => {
            if(index < countElem){
                let obj = {};

                for(let i in list[index]){
                    obj.description = list[index][i];
                }
                for(let i in list[index + (countElem)]){
                    obj.img = list[index + (countElem)][i];
                }
                arr.push(obj);
            }
        });
        state.advantageList = arr;
    },
    [SET_ADVANTAGE_LIST_LOADING](state, status) {
        state.advantageListLoading = status;
    },
    [GET_MAIN_SLIDER_LOADING](state, status) {
        state.mainSliderLoading = status;
    },
    [SET_MAIN_SLIDER](state, list) {
        state.mainSlider = list;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
